// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__2nw1P","slider":"switch_slider__24SZz","round":"switch_round__2KZAG"};